import { render, staticRenderFns } from "./UserWaterTrend.vue?vue&type=template&id=9647ad78&scoped=true"
import script from "./UserWaterTrend.vue?vue&type=script&lang=js"
export * from "./UserWaterTrend.vue?vue&type=script&lang=js"
import style0 from "./UserWaterTrend.vue?vue&type=style&index=0&id=9647ad78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9647ad78",
  null
  
)

export default component.exports